import React, { useState, useEffect, useRef } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import "./BookingEdit.css";
import { useParams, useLocation } from "react-router-dom";
import loader from "../Animations/Sandy Loading.gif";
import { useSelector } from "react-redux";
import PatientDetails from "./PatientDetails";
import FamilyDetails from "./FamilyDetails";
import ServiceDetails from "./ServiceDetails";
import ClinicalAssessmet from "./ClinicalAssessmet";
import Quotations from "./Quotations";
import { PopupModal } from "../PopupModal/PopupModal";
import BookingList from "./BookingList";
import MedicalHistory from "./MedicalHistory";
const BookingEdit = () => {
  const hasMergedTempRef = useRef(false);
  const location = useLocation();
  const { id } = useParams();
  const tempData = useSelector((state) => state.bookingForm.tempData);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState(null);
  const [form, setForm] = useState(null);
  const [interaction, setInteraction] = useState(null);
  const [clinicalAssessment, setClinicalAssessment] = useState(null);
  const [quotations, setQuotations] = useState(null);
  const [quoteForm, setQuoteForm] = useState({
    id: null,
    reason: "",
    publish_to_patient: false,
    accepted_by_patient: false,
    accepted_date_time: null,
  });
  const [popupType, setpopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setIsEditMode(location?.state?.mode === "edit");
  }, [location?.state]);

  const formatAcceptedDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);

    const time = d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const date = d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return `${time}, ${date}`;
  };

  const fetchBooking = async () => {
    try {
      setLoading(true);
      const patientRes = await axiosConfig.get(`/accounts/patients/${id}/`);
      const patient = patientRes.data;
      setBooking(patient);
      const leadId = patient?.lead?.id;
      let leadServices = [];
      if (leadId) {
        const res = await axiosConfig.get(
          `/accounts/leadservices/?lead=${leadId}`,
        );
        leadServices = res?.data?.results || [];
      }
      const primaryService = leadServices[0] || {};
      const lead = primaryService?.lead || {};
      setForm({
        id: patient?.id || "",
        lead_id: patient?.lead?.id || "",
        booking_id: patient?.lead?.lead_id || "",
        mobileno: patient?.lead?.mobileno || "",
        name: patient?.lead?.name || "",
        city: lead?.city || "",
        source: lead?.lead_source || "",
        datetime: formatAcceptedDate(
          patient?.lead?.created_date,
          patient?.lead?.time,
        ),
        service_name:
          primaryService?.service_name || patient?.service_name || "",

        service_type: primaryService?.service_type || "",
        service: primaryService?.service || [],
        expected_start_date: patient?.expected_start_date || "",
        estimated_duration_days: patient?.estimated_duration_days || "",
        full_name: patient?.full_name || "",
        patient_age: patient?.patient_age || "",
        patient_gender: patient?.patient_gender || "",
        service_gender: patient?.service_gender || "",
        weight: patient?.weight || "",
        height: patient?.height || "",
        medical_notes: patient?.medical_notes || "",
        documents: patient?.documents || [],
      });
    } catch (err) {
      console.error("Error fetching booking details", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      hasMergedTempRef.current = false;
      fetchBooking();
    }
  }, [id]);
  useEffect(() => {
    if (!booking?.lead?.id) return;

    const fetchInteraction = async () => {
      try {
        const res = await axiosConfig.get(
          `/accounts/interactions/?lead=${booking?.lead?.id}`,
        );

        const result = res?.data?.results || null;
        setInteraction(result);
      } catch (err) {
        console.error("Error fetching interaction", err);
      }
    };

    fetchInteraction();
  }, [booking?.lead?.id]);
  useEffect(() => {
    if (!booking?.lead?.id) return;

    const fetchClinicalAssessment = async () => {
      try {
        const res = await axiosConfig.get(
          `/accounts/clinical-assessments/?lead=${booking?.lead?.id}`,
        );

        const result = res?.data?.results || null;
        setClinicalAssessment(result);
      } catch (err) {
        console.error("Error fetching clinical assessment", err);
      }
    };

    fetchClinicalAssessment();
  }, [booking?.lead?.id]);
  useEffect(() => {
    const leadId = booking?.lead?.id;
    if (!leadId || quotations?.length) return;
    const fetchQuotation = async () => {
      try {
        const res = await axiosConfig.get(
          `/accounts/patient/leads/${leadId}/quote-items/`,
        );
        setQuotations(res?.data || []);
      } catch (err) {
        console.error("Error fetching quotations", err);
      }
    };

    fetchQuotation();
  }, [booking?.lead?.id, quotations?.length]);

  const fecthReason = async () => {
    try {
      const res = await axiosConfig.get(
        `/accounts/quote-price-adjust-reasons/?lead=${booking?.lead?.id}`,
      );

      const results = res?.data?.results;

      if (Array.isArray(results) && results.length > 0) {
        const record =
          results.find((r) => r.lead === booking?.lead?.id) || results[0];

        setQuoteForm({
          id: record?.id,
          reason: record?.reason || "",
          publish_to_patient: !!record?.publish_to_patient,
          accepted_by_patient: !!record?.accepted_by_patient,
          accepted_date_time: record?.accepted_date_time,
        });
      } else {
        setQuoteForm({
          id: null,
          reason: "",
          publish_to_patient: false,
          accepted_by_patient: false,
          accepted_date_time: null,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!booking?.lead?.id) return;
    fecthReason();
  }, [booking?.lead?.id]);

  useEffect(() => {
    if (!booking || !form) return;
    if (hasMergedTempRef.current) return;

    const savedData = tempData?.[booking?.lead?.lead_id];

    if (savedData && Object.keys(savedData).length > 0) {
      setForm((prev) => ({
        ...prev,
        ...Object.fromEntries(
          Object.entries(savedData).filter(
            ([_, v]) => v !== "" && v !== null && v !== undefined,
          ),
        ),
      }));
    }

    hasMergedTempRef.current = true;
  }, [booking, form, tempData]);

  if (loading && !form) {
    return (
      <div className="loader-wrapper">
        <img src={loader} alt="Loading..." />
      </div>
    );
  }

  const isAcceptedByPatient = quoteForm?.accepted_by_patient;
  console.log("isAcceptedByPatient", isAcceptedByPatient);

  return (
    <>
      <div className="patient-dashboard-child">
        <div className="profile">
          <h3>My Bookings </h3>
          <button className="book-service-btn">Book Service</button>
        </div>

        {form && (
          <>
            {booking && <BookingList bookings={[booking]} mode="summary" />}
            <PatientDetails
              form={form}
              setForm={setForm}
              isLocked={isAcceptedByPatient}
            />
            <MedicalHistory
              form={form}
              setForm={setForm}
              isLocked={isAcceptedByPatient}
            />
            <FamilyDetails
              form={form}
              setForm={setForm}
              isLocked={isAcceptedByPatient}
            />
            <ServiceDetails
              form={form}
              setForm={setForm}
              isLocked={isAcceptedByPatient}
            />
            {clinicalAssessment && (
              <ClinicalAssessmet clinicalAssessment={clinicalAssessment} />
            )}
            {isAcceptedByPatient && (
              <>
                <Quotations
                  quotations={quotations}
                  leadId={booking?.lead?.id}
                />
                <div className="bd-field accept-quote-field">
                  <div className="accepted-status">
                    <span className="accepted-icon">✔</span>
                    <span className="accepted-text">
                      Accepted By Patient |{" "}
                      {formatAcceptedDate(quoteForm?.accepted_date_time)}
                    </span>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={message}
          error={error}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default BookingEdit;
